import React, { useState } from "react";
import "./style.css";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { Link } from "react-router-dom";
import { logotext, socialprofils } from "../config/siteContent";

const Headermain = () => {
  const [isActive, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!isActive);
    document.body.classList.toggle("ovhidden");
  };

  return (
    <>
      <header className="fixed-top site__header">

        <div className="d-flex align-items-center justify-content-between">

          <Link className="navbar-brand nav_ac" to="/">
            {logotext}
          </Link>

          <button
            className="menu__button nav_ac"
            onClick={handleToggle}
          >
            {isActive ? <VscClose /> : <VscGrabber />}
          </button>

        </div>

        <div className={`site__navigation ${isActive ? "menu__opend" : ""}`}>

          <div className="bg__menu h-100">

            <div className="menu__wrapper">

              <div className="menu__container p-3">

                <ul className="the_menu">

                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/" className="my-3">
                      Home
                    </Link>
                  </li>

                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/photo" className="my-3">
                      Photo
                    </Link>
                  </li>

                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/video" className="my-3">
                      Vidéo
                    </Link>
                  </li>

                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/lumiere" className="my-3">
                      Lumière
                    </Link>
                  </li>

                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/contact" className="my-3">
                      Contact
                    </Link>
                  </li>

                </ul>

              </div>

            </div>

          </div>

          <div className="menu_footer d-flex flex-column flex-md-row justify-content-between align-items-md-center position-absolute w-100 p-3">

            <div className="d-flex">

              <a
                href={socialprofils.linkedin}
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>

              <a
                href={socialprofils.instagram}
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>

            </div>

            <p className="copyright m-0">
              © {logotext}
            </p>

          </div>

        </div>

      </header>

      <div className="br-top"></div>
      <div className="br-bottom"></div>
      <div className="br-left"></div>
      <div className="br-right"></div>

    </>
  );
};

export default Headermain;
